import $ from 'jquery';
import OrderingMenu from '../controls/OrderingMenu.js';

class TableContextMenuUtil {
    static setup(table, x, y) {
        const menu = new OrderingMenu();

        $.disableContextMenuForCurrentEvent();

        const columnsConfig = table.getColumnsConfig();
        const columns = [];

        for (let [key, item] of Object.entries(columnsConfig)) {
            columns.push({ name: key, order: item.order, label: item.label, visible: item.visible });
        }

        columns.sort((a, b) => { a = a.order; b = b.order; return a < b ? -1 : a > b ? 1 : 0 });

        for (const column of columns) {
            if (column.name === 'SEL') continue;
            menu.addItem(column.name, column.label, column.visible);
        }

        menu.prepareShow().$el.show().focus();

        const repositionOptions = {
            targetOffset: {left: x, top: y},
            targetHeight: 0,
            targetWidth: 0,
            targetRtl: false,
            anchor: 'start bottom',
            position: 'start top',
            updateWidth: false
        };

        menu.repositionAndResize(repositionOptions);

        const boundRepositionAndResize = function () {
            menu.repositionAndResize(repositionOptions);
        };

        $(window).on('resize', boundRepositionAndResize);

        menu
            .on('orderchange', (src, dest, oldIndex, newIndex) => {
                table.moveColumn(src, dest || newIndex);
            })
            .on('check', event => {
                table.setColumnVisible(event.item.value, event.item.checked);
            });


        const onShowColumn = columnName => {
            menu.setItemChecked(columnName, true);
        };

        table.on('showcolumn', onShowColumn);

        menu.$el
            .on('blur', () => {
                menu.remove();
                table.off('showcolumn', onShowColumn);
                $(window).off('resize', boundRepositionAndResize);
            });

        return this;
    }
}

export default TableContextMenuUtil;

